var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Three_dot_V",
    "data-name": "Three dot V",
    transform: "translate(-562.438 -509.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60257",
    "data-name": "Group 60257",
    transform: "translate(1518.438 -8667.227)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4733",
    "data-name": "Ellipse 4733",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-956 9177)",
    fill: "#66939e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4734",
    "data-name": "Ellipse 4734",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-956 9183)",
    fill: "#66939e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4735",
    "data-name": "Ellipse 4735",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-956 9189)",
    fill: "#66939e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotV);
export default __webpack_public_path__ + "static/media/Three dot V.3918a5faed42341722d87f94d69e8abf.svg";
export { ForwardRef as ReactComponent };